<template>
    <div class="viewer-document-box">
        <DocumentCard
            v-bind="documentCardProps"
            ref="documentCardRef"
        />
    </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref, computed } from 'vue';
import { modalDefinedEmits, type ToolbarReference, useModalBuilder } from '@helpers/modal-building-helper';
import { DxButton } from 'devextreme-vue/button';
import DocumentCard from '@components/document-card/DocumentCard.vue';
import type { IDocumentCardProps, IDocumentInitialState } from '@components/document-card/models/IDocumentCardProps';
import type { IViewerDocumentBoxProps } from './models/IViewerDocumentBoxProps';

const documentCardRef = ref<InstanceType<typeof DocumentCard>>();

const props = withDefaults(defineProps<IViewerDocumentBoxProps>(), {
  title: '',
  documentList: () => [],
  align: 'horizontal',
});

const documentCardProps = computed<IDocumentCardProps>(() => {
  return {
    title: props.title,
    actions: ['open', 'download'],
    align: props.align,
    initialDocumentList: props.documentList
  };
});

onMounted(() => {
    const modal = useModalBuilder();
    modal.setContext(getCurrentInstance()!);

    configureButtons(modal);
});

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
    let closeButton: ToolbarReference<DxButton>;
    closeButton = modal.standardButtons.addClose();

    closeButton.update(w => w.onClick = () => modal.close());
}

defineEmits([...modalDefinedEmits]);
</script>

<style scoped lang="scss">
.viewer-document-box {
    display: flex;
    justify-content: center;
}
</style>
